export default __webpack_public_path__ + "media/images/work_with_us/team-pic-1-56befeb1445915bf944583cabdf23ae3.webp";